// Директива для того чтобы привызявать любой всплывающий блок к body, но с координатами родительского элемента

export default {
  inserted(el, binding, { context }) {
    if (binding.value) {
      // binding.value - это значение указанное в директиве v-appent-to-body="value" (элемент к которому привязывать координаты)
      // Если $refs массивом, то берем первый элемент в массиве. Затем высчитываем его координаты.
      const element =
        context.$refs[binding.value].length !== undefined
          ? context.$refs[binding.value][0]
          : context.$refs[binding.value];

      const { height, top, left, width } = element.getBoundingClientRect();

      let scrollX = window.scrollX;
      let scrollY = window.scrollY;

      el.unbindPosition = context.calculatePosition(el, context, {
        width: width + 'px',
        left: scrollX + left + 'px',
        top: scrollY + top + height + 'px'
      });

      document.body.appendChild(el);
    }
  },

  unbind(el, binding) {
    if (binding.value) {
      if (el.unbindPosition && typeof el.unbindPosition === 'function') {
        el.unbindPosition();
      }
      if (el.parentNode) {
        el.parentNode.removeChild(el);
      }
    }
  }
};
